import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useToolTab } from '../../contexts/ToolTabContext';
import '../../style/tool-tab.css';

function ToolTabContainer() {
  const { isOpen, setOpen, panels, activePanel, setActivePanel, header, layout } = useToolTab();
  const navigate = useNavigate();

  if (panels.length === 0 && !(header?.shortcuts?.length > 0)) return null;

  const activeEntry = panels.find((p) => p.id === activePanel);
  const hasHeader = !!header;
  const isStacked = layout === 'stack';
  const shortcuts = Array.isArray(header?.shortcuts) ? header.shortcuts : [];

  const closeButton = (
    <button
      type="button"
      className="tool-tab-close"
      onClick={() => setOpen(false)}
      aria-label="패널 닫기"
    >
      <span className="material-symbols-rounded">close</span>
    </button>
  );

  const tabs = (
    <div className="tool-tab-tabs" role="tablist">
      {panels.map((panel) => (
        <button
          key={panel.id}
          type="button"
          role="tab"
          aria-selected={activePanel === panel.id}
          className={`tool-tab-tab btn-rtg${activePanel === panel.id ? ' active btn-primary' : ' btn-monotone-1'}`}
          onClick={() => {
            setActivePanel(panel.id);
            if (!isOpen) setOpen(true);
          }}
          title={panel.label}
        >
          <span className="material-symbols-rounded">{panel.icon}</span>
          {hasHeader && (
            <span className="tool-tab-tab-text">{panel.tabLabel || panel.label}</span>
          )}
          {panel.badge > 0 && (
            <span className="tool-tab-tab-badge">{panel.badge}</span>
          )}
        </button>
      ))}
    </div>
  );

  return (
    <div
      className={`tool-tab-container${isOpen ? ' open' : ''}${hasHeader ? ' has-context-header' : ''}${isStacked ? ' is-stacked' : ''}`}
      aria-label="도구 패널"
    >
      {hasHeader ? (
        <>
          <div className="tool-tab-context-header tool-tab-context-header-compact">
            <div className="tool-tab-context-copy">
              {header.kicker && (
                <div className="tool-tab-context-kicker">{header.kicker}</div>
              )}
              <div className="tool-tab-context-title" title={header.title}>
                {header.title}
              </div>
              {header.description && (
                <div className="tool-tab-context-description">
                  {header.description}
                </div>
              )}
            </div>
          </div>

          {shortcuts.length > 0 && (
            <div className="tool-tab-context-actions" aria-label="바로가기">
              {shortcuts.map((lnk) => (
                <button
                  key={lnk.path || lnk.label}
                  type="button"
                  className={`tool-tab-context-action${lnk.primary ? ' primary' : ''}`}
                  onClick={() => {
                    if (typeof lnk.onClick === 'function') lnk.onClick();
                    else if (lnk.path) navigate(lnk.path);
                  }}
                >
                  {lnk.icon && (
                    <span className="material-symbols-rounded">{lnk.icon}</span>
                  )}
                  {lnk.label}
                </button>
              ))}
            </div>
          )}

          {!isStacked && panels.length > 1 && (
            <div className="tool-tab-header tool-tab-header-tabs-only">
              {tabs}
            </div>
          )}
        </>
      ) : (
        <div className="tool-tab-header">
          {tabs}
          {closeButton}
        </div>
      )}

      {!hasHeader && !isStacked && activeEntry && (
        <div className="tool-tab-section-title">{activeEntry.label}</div>
      )}

      {panels.length > 0 && (
        <div className={`tool-tab-body${isStacked ? ' tool-tab-body--stacked' : ''}`} role="tabpanel">
          {isStacked ? (
            panels.map((panel) => (
              <div key={panel.id} className="widget-item tool-widget-card">
                {panel.component}
              </div>
            ))
          ) : (
            activeEntry?.component ?? null
          )}
        </div>
      )}
    </div>
  );
}

export default ToolTabContainer;
